import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { config } from '@/app/providers/logto.config';
import { ReleaseWatcher } from '@/app/shell/versionCheck';
import { persistor, store } from '@/app/store';
import { ToastRegion } from '@/view/shared/Toast';
import { LogtoProvider } from '@logto/react';
import { type ReactNode, StrictMode } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

export function AppProviders({ children }: { readonly children: ReactNode }): ReactNode {
  return (
    <StrictMode>
      <ToastRegion />
      <LogtoProvider config={config}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <ThemeProvider>
                <ReleaseWatcher />
                {children}
              </ThemeProvider>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </LogtoProvider>
    </StrictMode>
  );
}
